import React, { ComponentType, PureComponent } from 'react';
import { SaferPayScriptContext } from '../services/SaferPayScriptContext';

const withSaferPayScriptContext = <P extends object>(Component: ComponentType<P>) => {
  class WithSaferPayScriptContext extends PureComponent<P> {
    render() {
      return (
        <SaferPayScriptContext.Consumer>
          {value => <Component {...this.props} {...value} />}
        </SaferPayScriptContext.Consumer>
      );
    }
  }

  return WithSaferPayScriptContext;
};

export default withSaferPayScriptContext;
